module.exports = __webpack_public_path__ + "media/bootstrap-icons/telephone-minus-423f8250.svg";